/**
 * Libellé du combo Mission U3204 : titre U3203 seul (BL-0383).
 * Fallback sur le code si le titre est vide (évite une ligne blanche).
 */
export function u3204BuildAccessibleMissionComboLabel(input: {
  title?: string | null;
  code?: string | null;
}): string {
  const title = input.title?.trim() ?? '';
  if (title) {
    return title;
  }
  return input.code?.trim() ?? '';
}
